// NoticeDetail.jsx
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "./Notice.module.css";

export default function NoticeDetail() {
  const { id } = useParams();
  const [notice, setNotice] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`/api/support/notices/${id}`, { credentials: "include" })
      .then((res) => res.json())
      .then(setNotice);
  }, [id]);

  if (!notice) return null;

  const createdAt = (notice.createdAt || notice.created_at || "").slice(0, 10);

  return (
    <main className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>공지사항</h1>
      </div>

      {/* 🔹 2컬럼 그리드 상세 영역 */}
      <section className={styles.noticeDetail}>
        {/* 제목 */}
        <div className={styles.cellLabel}>제목</div>
        <div className={styles.cellValue}>{notice.title}</div>

        {/* 작성일 */}
        <div className={styles.cellLabel}>작성일</div>
        <div className={styles.cellValue}>{createdAt}</div>

        {/* 내용 */}
        <div className={styles.cellLabel}>내용</div>
        <div className={`${styles.cellValue} ${styles.cellValueContent}`}>
          {notice.content?.split("\n").map((line, idx) => (
            <p key={idx}>{line}</p>
          ))}
        </div>
      </section>

      <div className={styles.detailFooter}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          목록으로
        </button>
      </div>
    </main>
  );
}
